module.exports = __webpack_public_path__ + "img/7140.0c9ba737.jpg";